// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Import CSPHelper to manage Content Security Policy
import CSPHelper from './CSPHelper';

// Import auth components from the barrel file
import { Login, Signup, ForgotPassword, ProtectedRoute } from './auth';
import EmailVerification from './auth/EmailVerification';

// Other imports
import Dashboard from './authpages/dashboard/Dashboard';
import Profile from './authpages/profile/Profile';
import StudyGroup from './authpages/group/StudyGroup';
import StudyTimers from './authpages/timers/StudyTimers';
import StudyTimetable from './authpages/timetables/StudyTimetable';
import LandingPage from './landing/LandingPage';
import AuthLayout from './layout/AuthLayout';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';

// Import AuthProvider
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <Router>
      {/* Add CSPHelper to dynamically manage CSP */}
      <CSPHelper />
      
      <AuthProvider>
        <Routes>
          {/* Public routes with Navbar */}
          <Route path="/" element={
            <>
              <Navbar />
              <LandingPage />
              <Footer />
            </>
          } />
          <Route path="/login" element={
            <>
              <Navbar />
              <Login />
              <Footer />
            </>
          } />
          <Route path="/signup" element={
            <>
              <Navbar />
              <Signup />
              <Footer />
            </>
          } />
          <Route path="/forgot-password" element={
            <>
              <Navbar />
              <ForgotPassword />
              <Footer />
            </>
          } />
          
          {/* Email verification route */}
          <Route path="/verify-email" element={
            <>
              <Navbar />
              <EmailVerification />
              <Footer />
            </>
          } />
          
          {/* Protected routes wrapped with AuthLayout */}
          <Route element={<AuthLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/timetable" element={<StudyTimetable />} />
            <Route path="/study-timer" element={<StudyTimers />} />
            <Route path="/study-group" element={<StudyGroup />} />
          </Route>
          
          {/* Additional route for /timetables */}
          <Route path="/timetables" element={<StudyTimetable />} />
          
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;